const editorStore = {}
/**
 * This provides a way to persist data on closing ckeditor,
 * so that when the editor is loaded again, it retains previously typed data
 */
export default {
  data() {
    return {
      ckeditorId: null
    }
  },
  methods: {
    getEditorInstance() {
      return typeof CKEDITOR !== 'undefined' && CKEDITOR.instances[this.ckeditorId]
    },
    initializeEditorPersistence({ editorId }) {
      this.ckeditorId = editorId
    },
    clearEditorStoredData() {
      delete editorStore[this.ckeditorId]
    },
    loadEditorWithStoredData() {
      const editorInstance = this.getEditorInstance()
      if (editorInstance && editorStore[this.ckeditorId]) {
        editorInstance.setData(editorStore[this.ckeditorId])
      }
    },
    getEditorData() {
      return editorStore[this.ckeditorId]
    }
  },
  beforeDestroy() {
    const editorInstance = this.getEditorInstance()
    if (editorInstance) {
      editorStore[this.ckeditorId] = editorInstance.getData()
    }
  }
}
